import { hasAnyPermission, useAuthorization } from '@frontend/authorization';
import { EntityType, Rights } from '@frontend/common';
import { useActiveModal, useModals } from '@frontend/modal';
import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

const useSpotDetailModal = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { closeAllModals, closeModal, openModal } = useModals();
    const { modalId } = useActiveModal();
    const { permissions } = useAuthorization();

    const canReadIdentifications =
        permissions != null &&
        currentAccount != null &&
        hasAnyPermission(permissions, [{ item: EntityType.IDENTIFICATION, source: EntityType.ACCOUNT, right: Rights.READ, uid: currentAccount }]);

    async function viewDetailedConstraintsList(spot_id: string) {
        await navigate(`/constraints/constraints?spot_id=${spot_id}`);
        closeModal(modalId);
    }

    return {
        currentAccount,
        dispatch,
        navigate,
        closeAllModals,
        openModal,
        viewDetailedConstraintsList,
        canReadIdentifications
    };
};

export default useSpotDetailModal;
